
import moment from 'moment';
import { getData, getTimestampData } from '@/components/report/service';
import { SqlBase } from '../Sql/common'
import { TotalQuery, ProductQuery } from '../Sql/Totals';
import {
  TrackLineQuery,
  TrackLineTypeQuery,
  DepartureQuery
} from '../Sql/Modals';

const defualtDateFormat = 'YYYY-MM-DD';
const dateRange = [
  moment(new Date()).add(-14, 'days'),
  moment(new Date()).add(0, 'days')
]
export default {
  namespace: 'forecastCenterDepartBoardModals',
  state: {
    defualtDateFormat: defualtDateFormat,
    dateRange: dateRange,
    dateType: undefined,
    modalLoading: false,
    modalVisible: false,
    modalTitle: '',
    modalFiller: {},
    modalType: 1, // 弹层类型
    modalData: [],
    modalData2: []
  },
  effects: {
    // 重置
    *setReset(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          dateRange: dateRange,
          modalData: [],
          modalVisible: false,
          dateType: undefined
        },
      });
    },
    // 点击显示弹层
    *getSelect({ payload }, { put, select }) {
      let modalType = yield select(({ forecastCenterDepartBoardModals }) => 
        forecastCenterDepartBoardModals.modalType);
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      const type = payload && payload.modalType || modalType;
      if (type === 1) {
        yield put({ type: 'forecastCenterDepartBoardTransitDelivery/getSelect' });
      } else if (type === 2) {
        yield put({ type: 'forecastCenterDepartBoardSiteDepartModal/getSelect' });
      } else if (type === 3) {
        yield put({ type: 'forecastCenterDepartBoardSiteArriveModal/getSelect' });
      } else if (type === 4) {
        yield put({ type: 'forecastCenterDepartBoardVolumesModal/getSelect' });
      } else if (type === 5) {
        yield put({ type: 'forecastCenterDepartBoardDeliveryTotal/getSelect' });
      }
    },
    
    /**
     * 已发车 下一站 查当前网点14天记录
    */
    *getDeparture(_, { call, put, select }) {

      let centerFilter = yield select(({ forecastCenterDepartBoard }) => forecastCenterDepartBoard.searchParams.centerFilter);
      let query = yield select(({ forecastCenterDepartBoardModals }) => {
        return {
          title: forecastCenterDepartBoardModals.modalTitle,
          startDate: moment(forecastCenterDepartBoardModals.dateRange[0]),
          endDate: moment(forecastCenterDepartBoardModals.dateRange[1]),
        }
      });
      const filter = DepartureQuery({
        startDate: query.startDate.format('YYYY-MM-DD 12:00:00'),
        endDate: query.endDate.format('YYYY-MM-DD 12:00:00'),
        scanSite: centerFilter,
        siteName: query.title,
      });
      const params = {
        aggregators: SqlBase(),
      }
      const data = yield call(getTimestampData, { ...params, ...filter[0] });
      const items = [];
      data && data.forEach(item => {
        const goodsWeight = item.goodsWeight ? (Math.abs(item.goodsWeight) / 1000).toFixed(2) : 0;
        items.push({
          name: moment(item.timestamp).format('YYYY-MM-DD'),
          value: goodsWeight
        })
      });
      yield put({
        type: 'update',
        payload: {
          modalData: items
        },
      });
    },
    /**
     * 已发车 省区查14天记录
    */
    *getDepartureArea(_, { call, put, select }) {

      let centerFilter = yield select(({ forecastCenterDepartBoard }) => forecastCenterDepartBoard.searchParams.centerFilter);
      let query = yield select(({ forecastCenterDepartBoardModals }) => {
        return {
          title: forecastCenterDepartBoardModals.modalTitle,
          startDate: moment(forecastCenterDepartBoardModals.dateRange[0]),
          endDate: moment(forecastCenterDepartBoardModals.dateRange[1]),
          nextProvinceArea: forecastCenterDepartBoardModals.modalFiller?.nextProvinceArea
        }
      });
      const filter = DepartureQuery({
        startDate: query.startDate.format('YYYY-MM-DD 12:00:00'),
        endDate: query.endDate.format('YYYY-MM-DD 12:00:00'),
        scanSite: centerFilter,
        nextProvinceArea: query.nextProvinceArea,
      });
      const params = {
        aggregators: SqlBase(),
      }
      const data = yield call(getTimestampData, { ...params, ...filter[1] });
      const items = [];
      data && data.forEach(item => {
        const goodsWeight = item.goodsWeight ? (Math.abs(item.goodsWeight) / 1000).toFixed(2) : 0;
        items.push({
          name: moment(item.timestamp).format('YYYY-MM-DD'),
          value: goodsWeight
        })
      });
      yield put({
        type: 'update',
        payload: {
          modalData2: items
        },
      });
    },




    /**
     * 线路查询
    */
    *getTrankLine(_, { call, put, select }) {
      let centerFilter = yield select(({ forecastCenterDepartBoard }) => forecastCenterDepartBoard.searchParams.centerFilter);
      let query = yield select(({ forecastCenterDepartBoardModals }) => {
        return {
          title: forecastCenterDepartBoardModals.modalTitle,
          startDate: moment(forecastCenterDepartBoardModals.dateRange[0]),
          endDate: moment(forecastCenterDepartBoardModals.dateRange[1]),
        }
      });
      const filter = TrackLineQuery({
        startDate: query.startDate.format('YYYY-MM-DD 12:00:00'),
        endDate: query.endDate.format('YYYY-MM-DD 12:00:00'),
        scanSite: centerFilter,
        trackLine: query.title,
      });
      const params = {
        aggregators: SqlBase(),
      }
      const data = yield call(getTimestampData, { ...params, ...filter });
      const items = [];
      data && data.forEach(item => {
        const goodsWeight = item.goodsWeight ? (Math.abs(item.goodsWeight) / 1000).toFixed(2) : 0;
        items.push({
          name: moment(item.timestamp).format('YYYY-MM-DD'),
          value: goodsWeight
        })
      });
      yield put({
        type: 'update',
        payload: {
          modalData: items
        },
      });
    },
    /**
     * 通过线路查产品类型数据统计
    */
    *getTrankLineType(_, { call, put, select }) {
      let centerFilter = yield select(({ forecastCenterDepartBoard }) => forecastCenterDepartBoard.searchParams.centerFilter);
      let query = yield select(({ forecastCenterDepartBoardModals }) => {
        return {
          title: forecastCenterDepartBoardModals.modalTitle,
          startDate: moment(forecastCenterDepartBoardModals.dateRange[0]),
          endDate: moment(forecastCenterDepartBoardModals.dateRange[1]),
        }
      });
      const params = {
        simpleGranularity: 'all',
        startDate: query.startDate.format('YYYY-MM-DD 12:00:00'),
        endDate: query.endDate.format('YYYY-MM-DD 12:00:00'),
        aggregators: SqlBase(),
      }
      const filter = TrackLineTypeQuery(query.title, centerFilter);
      const items = [];
      for (let i = 0; i < filter.length; i++) {
        const data = yield call(getData, { ...params, ...filter[i] });
        let result = data[0] || null;
        const name = filter[i].andFilters[0].value;
        const goodsWeight = result ? (Math.abs(result.goodsWeight) / 1000).toFixed(2) : 0;
        items.push({
          name: name,
          value: goodsWeight
        })
      }
      yield put({
        type: 'update',
        payload: {
          modalData2: items
        },
      });
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
}